export const SESSION_TIMEOUT = 'Forgotpwd/SESSION_TIMEOUT'

export const INIT = 'AnalyticsRegister/INIT'
export const FETCH_DATA_ERROR = 'AnalyticsRegister/FETCH_DATA_ERROR'
export const FETCH_DATA_SUCCESS = 'AnalyticsRegister/FETCH_DATA_SUCCESS'

export const REQUEST_RECAPTCHA = 'AnalyticsRegister/REQUEST_RECAPTCHA'
export const REQUEST_RECAPTCHA_SUCCESS = 'AnalyticsRegister/REQUEST_RECAPTCHA_SUCCESS'
export const REQUEST_RECAPTCHA_ERROR = 'AnalyticsRegister/REQUEST_RECAPTCHA_ERROR'

export const SUBMIT_REQUEST = 'AnalyticsRegister/SUBMIT_REQUEST'
export const SUBMIT_REQUEST_SUCCESS = 'AnalyticsRegister/SUBMIT_REQUEST_SUCCESS'
export const SUBMIT_REQUEST_ERROR = 'AnalyticsRegister/SUBMIT_REQUEST_ERROR'

export const REQUEST_PHONE_CODES = 'AnalyticsRegister/REQUEST_PHONE_CODES'
export const REQUEST_PHONE_CODES_SUCCESS = 'AnalyticsRegister/REQUEST_PHONE_CODES_SUCCESS'
export const REQUEST_PHONE_CODES_ERROR = 'AnalyticsRegister/REQUEST_PHONE_CODES_ERROR'

export const CANCEL = 'Forgotpwd/CANCEL'

